import { render, staticRenderFns } from "./NorticSelectItem.vue?vue&type=template&id=7343ec40&scoped=true&"
import script from "./NorticSelectItem.vue?vue&type=script&lang=js&"
export * from "./NorticSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./NorticSelectItem.vue?vue&type=style&index=0&id=7343ec40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7343ec40",
  null
  
)

export default component.exports